import { TableCell, TableRow, Typography, Radio } from '@mui/material';
import { ChangeEvent } from 'react';
import Syllabus from '../../../../../../models/Syllabus';


interface SuggestionRowProps {
  row: Syllabus,
  isRowSelected: (value: Syllabus) => boolean,
  selectRow: (e: ChangeEvent<HTMLInputElement>, row: Syllabus) => void
}

const SuggestionRow:React.FC<SuggestionRowProps> = ({ row, isRowSelected, selectRow }) => {
  const onHandleChecked = (e: ChangeEvent<HTMLInputElement>) => {
    selectRow(e, row);
  };

  return (
    <TableRow data-testid={'row'} sx={{ display: 'table-row' }}>
      <TableCell className="REQXXI-Suggestion-Source" align="left" scope="row">
        {/* <Typography color="secondary" key={row?.id ? row.id : '' + row?.compatibility} marginRight={'10px'}>{row?.compatibility + ' %'}</Typography> */}
        <Typography key={row?.id}>{row?.name}</Typography>
      </TableCell>
      <TableCell className="REQXXI-Suggestion-target-check" align="left" scope="row">
        <Radio
          color="primary"
          checked={isRowSelected(row)}
          onChange={onHandleChecked}
          data-testid={'activeCheckbox'}
        />
      </TableCell>
    </TableRow>
  );
};

export default SuggestionRow;
